import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button, Logo } from 'components'
import styles from 'views/mydata/index.module.css'
import { linkedDataState } from '../states'
import { manageDataLayerState } from 'views/mydata/manage/states'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'

const ExtendLinkResultIndex = () => {

	const App = useApp()
	const navigate = useNavigate()
	const linkedData = useRecoilValue(linkedDataState)
	const resetLinkedData = useResetRecoilState(linkedDataState)
	const resetmanageDataLayerState = useResetRecoilState(manageDataLayerState)

	const onClick = () => {
		resetLinkedData()
		resetmanageDataLayerState()
		navigate("/mydata/management")
	}

	useEffect(() => {
		console.log(linkedData)
	}, [linkedData])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div className={styles["manage-title"]}>전송요구 종료시점이 연장되었습니다.</div>
				<div className="check-area mt_30">
					<div className="check-title">전체 <span>{linkedData.length}</span></div>
					<div className="check-list">
						{
							linkedData &&
							linkedData.map((item, index) => {
								return (
									<div key={index}>
										<div>
											<div className="img-box img-symbol">
												<Logo code={item.insttCd} style={{ width: "100%", height: "100%" }} />
											</div>
											<p className="ml_10 ellipsis" style={{ width: "17rem" }}>{item.insttNm}</p>
										</div>
										{
											item.sucesYn === "Y" &&
											<span className="connect">연장완료</span>
											||
											item.sucesYn === "N" &&
											<span className="connect fail">실패</span>
										}
									</div>
								)
							})
						}
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={onClick}>확인</Button>
			</div>
		</div>
	)
}

export default ExtendLinkResultIndex